const colors = {
  primary: '#E7CFA7',
  burgundy: '#23030A',
  lightburgundy: '#260B11',
  darkburgundy: '#1a0307;',
  red: '#92370F',
  darkred: '#110508',
  orange: '#E5C188',
  white: '#FFFFFF',
  black: '#242525',
  grey: '#B0B0B0',
  darkgrey: '#4B4B4B',
  extradarkgrey: '#161616',
  khaki: '#E5C88F',
  tertiary: '#1C1C1C',
  body: '#171719',
  redwine: '#300A0F',
  korall: '#FF5A5A',
  neonkorall: '#FC3A3A',
  dypkorall: '#E2182F',
};

const input = {
  label: colors.white,
  error: colors.red,
  labelAfter: 'rgb(50,50,50)',
  placeholder: colors.grey,
  background: colors.darkgrey,
  font: {
    size: '16.3px',
  },
};

const mediaSizes = {
  small: 600,
  medium: 800,
  large: 1140,
};

const buttons = {
  primary: {
    background: colors.primary,
    borderColor: '#fff',
    colorIcon: colors.primary,
    hover: colors.tertiary,
    color: '#000',
    themes: {
      gold: {
        background: colors.primary,
        color: '#000',
      },
      gray: {
        background: '#242525',
        color: colors.primary,
      },
    },
  },
  secondary: {
    borderColor: colors.primary,
    hover: colors.tertiary,
    color: '#fff',
  },
  tertiary: {
    borderColor: colors.primary,
    hover: colors.tertiary,
    color: '#fff',
  },
};

export const theme = {
  colors,
  input,
  mediaSizes,
  buttons,
};

type MediaSize = typeof mediaSizes;
type Theme = typeof theme;
declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
  export interface Media extends MediaSize {}
}
